<template>
  <div class="pay-form">
    <div class="pay-form-data" v-if="!loading">
      <label for="value">Доступные программы</label>
      <div class="programs-container">
        <div class="program" v-for="program in programs" :key="program.price">
          <button :class="{ chosen: chosenProgram && program.price === chosenProgram.price }"
            @click="choseProgram(program)"
          >
            {{ `${program.price} руб - ${program.minutes} мин.` }}
          </button>
        </div>
      </div>
      <div class="email-window">
        <label for="email">{{ emailError ? 'Неверный адрес почты' : 'Укажите ваш e-mail для получения чека' }}</label>
        <input id="email" type="text" :disabled="loading" class="pay-form__input" v-model="email" :class="{ error: !!emailError }" />
        <div class="checkbox">
          <label for="checkbox">Мне не нужен чек</label>
          <input id="checkbox" type="checkbox" v-model="noCheck" />
        </div>
      </div>
    </div>
    <button @click="onClick" :disabled="loading" >{{ !loading ? 'Оплатить' : 'Загрузка' }}</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  async created () {
    this.controllerId = this.$route.query.kid

    const res = await axios.get(`/pay/programs/?controllerId=${this.controllerId}`)

    this.programs = res.data
    this.chosenProgram = this.programs[0] || {}
  },

  data () {
    return {
      email: '',
      chosenProgram: null,
      emailError: false,
      payUrl: null,
      controllerId: '',
      noCheck: false,
      loading: false,
      programs: []
    }
  },

  methods: {
    choseProgram (program) {
      this.chosenProgram = program
    },

    isEmailError (email) {
      if (!email) return true

      return !(/\S+@\S+\.\S+/.test(email.toLowerCase()))
    },

    onClick () {
      this.validateForm()
    },

    async validateForm () {
      if (!this.controllerId) return

      this.emailError = this.isEmailError(this.email)

      if ((!this.emailError || this.noCheck) && this.controllerId) {
        this.loading = true

        const res = await axios.post('/pay', { email: this.email, program: this.chosenProgram, controllerId: this.controllerId, isNeedCheck: !this.noCheck })

        if (res.data.formUrl) {
          this.payUrl = res.data.formUrl
          window.location.href = this.payUrl;
        }

        this.loading = false
      }
    },

    onValueInput ({ target: { value } }) {
      if (/^\d+$/.test(value)) {
        this.value = value
      } else {
        this.value = ''
      }
    }
  }
}
</script>

<style>
.pay-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
}

.pay-form label {
  margin-bottom: 10px;
  text-align: center;
  font-size: 20px;
  color: #6d6f79;
}

.pay-form input:not(:last-child) {
  margin-bottom: 20px;
}

.pay-form input {
  padding: 10px 20px;
  font-size: 18px;
  color: #393b4b;
  border: 2px solid #f38034;
  border-radius: 6px;
}

.pay-form input:focus {
  outline: none;
  border: 2px solid #f38034;
}

.pay-form input.error {
  border: 2px solid #8b2e4d;
}

.pay-form > button {
  outline: none;
  padding: 10px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  border: 1px solid #ecc46d;
  background: #f38034;
  border-radius: 6px;
}

.pay-form > button:hover {
  color: #575555;
  background: #f0c05a;
  cursor: pointer;
}

.pay-form-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
}

.programs-container {
  display: flex;
  flex-wrap: wrap;
  width: 180px;
  margin-bottom: 20px;
}

.program button {
  outline: none;
  padding: 5px;
  width: 80px;
  margin-right: 10px;
  margin-bottom: 10px;
  color: #fff;
  background: #6d6f798e;
  border-radius: 8px;
  font-weight: bold;
}

.program button.chosen {
  background-color: #f38034;
}

.email-window {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 6px;
  box-sizing: border-box;
}

.checkbox {
  display: flex;
  align-items: center;
}

.checkbox > label {
  font-size: 14px;
  margin: 0;
}
</style>
